import React from 'react';
import { Bridge } from '../plugins/bridge';
import {Content} from "../types/types";
import {isMobile} from "react-device-detect";

interface Items {
    id: number;
    thumbnailPath: string;
    WebUrl: string;
    createdAt: Date;
}

interface MainContantImageProps {
    type?: 1 | 2;
    items: Content;
}

export const MainContantImage: React.FC<MainContantImageProps> = ({
                                                                      type = 1,
                                                                      items,
                                                                  }) => {
    if (!items) return null
    return (
        <div
            className={`${
                type === 1 ? 'aspect-w-4 aspect-h-5' : 'aspect-w-8 aspect-h-5'
            }  cursor-pointer main_photocard`}
            onClick={items.buttonLink ? () => window.open(`${items.buttonLink}`, '_parent') && Bridge.sendAmplitude('main_content_clicked', { content_id : items.id, content_name : items.title}) : undefined}
            key={items.id}
        >
            <img
                className="absolute w-full h-full object-cover"
                src={ isMobile ? (`${items.rawImageUrl?.replace('/uploads/', '/resized/')}`) : (`${items.rawImageUrl}`)}
                alt=""
            />
            { items.title && (
                <h1 className="text-15 md:ml-px font-semibold text-white text-left">
                    <h2 className={`mainContentsHover1 flex flex-col gap-y-2 items-center justify-center h-full bg-black bg-opacity-50 top-0 text-14 font-normal`}>
                        <p>
                            {items.title}
                        </p>
                        <p className={`text-black py-1 px-3 h-13 bg_3e52bb text-white text-center rounded-sm text-12`}>
                            보러 가기
                        </p>
                    </h2>
                    <div className={`mainContentsHover2`}>
                        <p className="ml-5" style={
                            {color: items.textColor ? items.textColor : "#FFFFFF"}
                        }
                        >{items.title}</p>
                    </div>
                </h1>
            )}
        </div>
    );
};
